import { useAppSelector } from "@/config/store";
import { AuthenticationState } from "@/shared/reducers/authentication";
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const PasswordExpirationPopUp = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [countdown, setCountdown] = useState<number>(0);
  const { account } = useAppSelector<AuthenticationState>(
    (state) => state.authentication
  );

  useEffect(() => {
    if (!account?.nextResetDate) return;
    const nextResetDate = new Date(account.nextResetDate);
    const currentDate = new Date();
    const timeForNextReset = nextResetDate.getTime() - currentDate.getTime();

    if (timeForNextReset <= 0) {
      navigate("/logout");
      return;
    }
    setCountdown(timeForNextReset);

    const passwordExpirationCheck = localStorage.getItem("passwordExpirationCheck");
    const oneDayInMilliseconds = 1000 * 60 * 60 * 24;
    const daysForNextReset = timeForNextReset / oneDayInMilliseconds;

    if (daysForNextReset <= 30) {
      if (!passwordExpirationCheck) {
        setOpen(true);
        return;
      }
      const passwordExpirationCheckDate = new Date(passwordExpirationCheck);
      const timeSinceLastCheck =
        new Date().getTime() - passwordExpirationCheckDate.getTime();

      if (
        daysForNextReset <= 30 &&
        timeSinceLastCheck >= oneDayInMilliseconds * 30
      ) {
        localStorage.removeItem("passwordExpirationCheck");
        setOpen(true);
      } else if (
        daysForNextReset <= 7 &&
        timeSinceLastCheck >= oneDayInMilliseconds * 7
      ) {
        localStorage.removeItem("passwordExpirationCheck");
        setOpen(true);
      } else if (
        daysForNextReset <= 1 &&
        timeSinceLastCheck >= oneDayInMilliseconds
      ) {
        localStorage.removeItem("passwordExpirationCheck");
        setOpen(true);
      }
    }
  }, [account?.nextResetDate, navigate]);

  const handleCheck = () => {
    localStorage.setItem("passwordExpirationCheck", new Date().toISOString());
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Scadenza password</DialogTitle>
        </DialogHeader>
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          La tua password scadrà tra{" "}
          {Math.floor(countdown / (1000 * 60 * 60 * 24))} giorni.
        </p>
        <DialogFooter>
          <Button onClick={handleCheck}>Continua</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PasswordExpirationPopUp;
